<div *ngIf="shouldShowSelect">
  <mat-form-field
    appearance="fill"
    class="select-user w-100"
    (click)="checkClear()"
    (keydown)="checkClear()">
    <mat-label class="main-font">Utente visionato</mat-label>
    <input
      type="text"
      matInput
      [formControl]="myUserControl"
      [matAutocomplete]="autoUser"
      [readonly]="changesDetected ? true : false" />
    <mat-autocomplete
      #autoUser="matAutocomplete"
      [displayWith]="displayUsersFn">
      <mat-option
        class="wdt-select-users main-font"
        *ngFor="let option of users"
        [value]="option"
        (onSelectionChange)="isClear ? selectUser(option) : checkClear(option)">
        {{ option.first_name + ' ' + option.last_name }}
      </mat-option>
    </mat-autocomplete>
    <button
      [style.visibility]="myUserControl.value ? 'visible' : 'hidden'"
      matTooltip="Deseleziona utente"
      matSuffix
      mat-icon-button
      (click)="
        stopEventPropagation($event); isClear ? resetUserSelect() : checkClear()
      ">
      <mat-icon>cancel</mat-icon>
    </button>
  </mat-form-field>
</div>
